import { render, staticRenderFns } from "./DictEditModal.vue?vue&type=template&id=051c5f67"
import script from "./DictEditModal.vue?vue&type=script&lang=js"
export * from "./DictEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports